<template>

  <svg role="presentation" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="363.6 113 93.6 93.5"><path fill="#AAA" d="M455 115c-6.5-6.5-60.6 3.9-76.1 19.4-12.6 12.6-13.5 33.7-2.4 49.3l-12.9 9.6 13.2 13.2 9.9-12.8c16.1 11.7 36.5 10.1 49-2.5 15.9-16.1 26.2-69.3 19.3-76.2z"/></svg>

</template>


<script>

  export default {"name":"icon-8c800a6d2a74a3997caa681d5eb90677"}

</script>